/* eslint-disable import/no-unresolved */
import { useState } from 'preact/hooks'
import { connect } from 'react-redux'
import { getP } from 'redux-polyglot'
import classNames from 'classnames'

import AppBar from 'components/app-bar'
import Redirect from 'components/common/redirect'
import styles from './styles.css'
import { LOGIN_STATUS_SUCCESS } from 'constants/login'
import { getAppName, isLoggedIn } from 'selectors/app'
import { getMessage, getMessageType, getLoading } from 'selectors/forgot-password'
import { getStatus } from 'selectors/login'
import { forgotPassword } from 'actions/forgot-password'

const ForgotPassword = ({
  polyglot: { t },
  appName,
  isLoggedIn,
  status,
  messageType,
  loading,
  message,
  forgotPassword,
}) => {
  const [email, setEmail] = useState('')
  if (isLoggedIn || status === LOGIN_STATUS_SUCCESS) {
    return <Redirect to={this.getRedirectUrl()} />
  }

  const onChange = e => {
    setEmail(e.target.value)
  }

  const onSubmit = e => {
    e.preventDefault()
    forgotPassword(email)
  }

  const messageClasses = classNames(styles.message, {
    [styles['message--success']]: messageType === 'success',
    [styles['message--alert']]: messageType === 'alert',
  })

  return (
    <div className="component">
      <div className="componentBody">
        <AppBar
          title={t('tv_auth.title_login', {
            _: 'Login with Username or Email and Password',
          })}
          subtitle={t('tv_auth.subtitle_login', {
            _: 'to continue with %{app_name}',
            app_name: appName,
          })}
        />

        <div className={styles.container}>
          <div className={styles.title}>Forgot password</div>
          <div className={styles.text}>
            Must be the e-mail address used during initial registration.
          </div>
          {message && <div className={messageClasses}>{message}</div>}
          <form onSubmit={onSubmit}>
            <div className={styles['form-control']}>
              <input type="text" placeholder="Email" value={email} onChange={onChange} />
            </div>
            <button type="submit" disabled={loading} className={styles['submit-button']}>
              Email me new password
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  isLoggedIn: isLoggedIn(state),
  polyglot: getP(state),
  appName: getAppName(state),
  status: getStatus(state),
  messageType: getMessageType(state),
  message: getMessage(state),
  loading: getLoading(state),
})

const mapDispatchToProps = {
  forgotPassword,
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)
